var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import ErrorIcon from '@mui/icons-material/Error';
import SuccessIcon from '@mui/icons-material/CheckCircle';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import Typography from '@mui/material/Typography';
import { cpaService } from 'services/api/cpa-service';
import { checkUserLockPreventsEdit, getPricingTableData, updateLockApi } from 'utils/cpa-utils';
import { BannerIconType, BannerMessageType } from 'components/Shared/BannerContext/BannerContext';
import styles from './CpaProductHeaderBanner.module.scss';
export function CpaProductHeaderBanner(_a) {
    var showBanner = _a.showBanner, message = _a.message, messageType = _a.messageType, iconType = _a.iconType, isRefreshEnabled = _a.isRefreshEnabled, isExtendedTimeEnabled = _a.isExtendedTimeEnabled, setIsExtendedTimeEnabled = _a.setIsExtendedTimeEnabled, setExtendTimeModelOpen = _a.setExtendTimeModelOpen, setIsLockExtended = _a.setIsLockExtended;
    var cpaProductContext = useCpaProduct();
    var messageClassName;
    var iconClassName;
    switch (messageType) {
        case BannerMessageType.Success:
            messageClassName = "".concat(styles.successMessageContainer, " ").concat(styles.messageContainer);
            iconClassName = "".concat(styles.icon);
            break;
        case BannerMessageType.Warning:
            messageClassName = "".concat(styles.warningMessageContainer, " ").concat(styles.messageContainer);
            iconClassName = "".concat(styles.icon, " ").concat(styles.iconError);
            break;
        case BannerMessageType.Error:
            messageClassName = "".concat(styles.errorMessageContainer, " ").concat(styles.messageContainer);
            iconClassName = "".concat(styles.icon, " ").concat(styles.iconExpiration);
            break;
        default:
            messageClassName = "".concat(styles.messageContainer);
            iconClassName = "".concat(styles.icon);
            break;
    }
    if (!showBanner) {
        return _jsx(Box, { className: styles.bannerContainer });
    }
    function setReloadRequest() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var cpn, getProductRsp, pricingRsp, pricingTableData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn)) return [3 /*break*/, 4];
                        cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                        return [4 /*yield*/, cpaService.getProduct(cpn, false)];
                    case 1:
                        getProductRsp = _b.sent();
                        getProductRsp.body.product.startDate = new Date().toISOString();
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_CURRENT_PRODUCT',
                            payload: __assign({}, getProductRsp.body.product),
                        });
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_CURRENT_PRODUCT_ORIGINAL',
                            payload: __assign({}, getProductRsp.body.product),
                        });
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_DEVIATION_DESC',
                            payload: getProductRsp.body.product.deviationDesc,
                        });
                        return [4 /*yield*/, cpaService.getPricing(cpn)];
                    case 2:
                        pricingRsp = _b.sent();
                        pricingTableData = getPricingTableData(__spreadArray([], ((_a = pricingRsp.body) !== null && _a !== void 0 ? _a : []), true));
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_PRICING_TABLE_DATA',
                            payload: __assign({}, pricingTableData),
                        });
                        return [4 /*yield*/, cpaService.getLockUpdateStorage(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn)];
                    case 3:
                        _b.sent();
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_EDITABLE_BUTTON',
                            payload: checkUserLockPreventsEdit(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn),
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var bannerActionComponent = null;
    if (isRefreshEnabled) {
        bannerActionComponent = (_jsx(Typography, __assign({ className: styles.pageTitle, style: {
                fontWeight: 'bold',
                textDecoration: 'underline',
                marginLeft: '8px',
                cursor: 'pointer',
            }, onClick: function () { return setReloadRequest(); } }, { children: "Refresh" })));
    }
    else if (isExtendedTimeEnabled) {
        bannerActionComponent = (_jsx(Typography, __assign({ className: styles.pageTitle, style: {
                fontWeight: 'bold',
                textDecoration: 'underline',
                marginLeft: '8px',
                cursor: 'pointer',
            }, onClick: function () {
                var lockString = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
                if (lockString) {
                    var lock = JSON.parse(lockString);
                    updateLockApi(cpaProductContext.data.cpn, lock.username, lock.sessionId, cpaProductContext.data.currentProduct.startDate);
                    setIsExtendedTimeEnabled(false);
                    setExtendTimeModelOpen(false);
                    setIsLockExtended(true);
                }
            } }, { children: "Extend Time" })));
    }
    else {
        bannerActionComponent = null;
    }
    return (_jsx(Box, __assign({ className: styles.bannerContainer }, { children: _jsxs(Box, __assign({ className: messageClassName }, { children: [iconType === BannerIconType.Error && _jsx(ErrorIcon, { className: iconClassName }), iconType === BannerIconType.Success && _jsx(SuccessIcon, { className: iconClassName }), message, bannerActionComponent] })) })));
}
